export default url;

class Url {

    constructor(url = location.href) {
        const queryStringStart = ~url.indexOf( '?' )
                ? url.indexOf( '?' )
                : url.length;

        this.url = url.substr( 0, queryStringStart );
        this.params = url.substr( queryStringStart + 1 )
                .split( '&' )
                .map( p => p.split( '=' ) )
                .filter( arr => arr.length == 2 )
                .reduce( (params, kv) => { params[kv[0]] = decodeURIComponent( kv[1] ); return params; }, {} );
    }

    read(name, defaults) {
        return name in this.params
                ? params[name]
                : defaults;
    }

    write(name, value) {
        this.params[name] = value;
        return this;
    }

    substitute(params) {
        Object.keys( params )
            .map( key => [key, params[key]] )
            .forEach( ([key, value]) => this.url = this.url.replaceAll( `{${key}}`, value ) );

        Object.keys( this.params )
            .filter( key => this.params[key].toString().match( /^\{[^\}]+\}$/ ) )
            .map( key => [key, this.params[key].toString()] )
            .map( ([key, mask]) => [key, mask.substring( 1, mask.length - 1 )] )
            .filter( ([key, name]) => name in params )
            .forEach( ([key, name]) => this.params[key] = '' + params[name] );

        return this;
    }

    toString() {
        const queryString = Object.keys( this.params )
                .filter( key => !this.params[key].toString().match( /^\{[^\}]+\}$/ ) )
                .map( key => `${key}=${encodeURIComponent( this.params[key] )}` )
                .join( '&' );

        return queryString.length > 0
                ? `${this.url}?${queryString}`
                : this.url;
    }

}

function url(url = location.href) {
    return new Url( url );
}


// WEBPACK FOOTER //
// ./src/js/urlify.js